module.exports = __webpack_public_path__ + "img/right-arrow.1e6e684c.svg";